module.exports = __webpack_public_path__ + "static/media/res13.3a77cbd6.PNG";